//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
import orderDetail from './orderDetail.vue'
import wxPay from "@/common/js/wxPay.js"
import tkiQrcode from "@/components/tki-qrcode/tki-qrcode.vue"
export default {
	mixins: [wxPay],
	data() {
		return {
			list: [],
			expressData: [], //物流的列表
			detail: {}, //订单的详情
			orderCode: '', //订单code
			orderType: '', //订单品类
			creatTime: '', //订单的创建时间
			address: '', //线路出发地
			useDate: '', //线路出发时间
			checkInTime: '', //酒店入住时间
			checkOutTime: '', //酒店离店时间
			serviceTime: '', //客服服务时间
			ShowCode: false, //券码展示的字段
			isRefund: false, //退款申请的字段
			valid: false, //有效期的字段
			leftTime: '00:00', //支付时间字段
			show: false,
			animation: false
		}
	},
	watch: {
		'detail.orderStatus'(val) {
			if (val === 10) {
				this.getLeftTime()
			}
		},
		show(val) {
			if (!val) {
				setTimeout(() => {
					this.animation = false
				}, 300)
			} else {
				this.animation = true
			}
		}
	},
	components: {
		orderDetail,
		tkiQrcode
	},
	computed: {
		//券码
		usedCode() {
			let orderClosedStatus = this.detail.orderClosedStatus
			let orderStatus = this.detail.orderStatus
			let usedCode = this.ShowCode
			if (orderStatus === 10 || (orderStatus === 100 && [0, 1, 5].includes(orderClosedStatus))) {
				usedCode = false
			} else {
				usedCode = true
			}
			return usedCode
		},
		//订单状态名称
		orderStatusName() {
			let rulesOrderClosedStatus = {
				0: '，超时未付款',
				1: '，已取消',
				2: '，券码已过期',
				3: '，退款成功',
				4: '，订单变更',
				5: '，产品信息变更'
			}
			let orderStatus = this.detail.orderStatus
			let orderClosedStatus = this.detail.orderClosedStatus
			let orderStatusName = this.detail.orderStatusDescription
			if (orderStatus === 20 && this.detail.refundStatusDescription) {
				orderStatusName = this.detail.refundStatusDescription
			} else if (orderStatus === 100) {
				orderStatusName += (rulesOrderClosedStatus[orderClosedStatus] || '')
			}
			return orderStatusName
		},
		//订单code
		orderId() {
			return this.detail.orderCode
		},
		//券码是否过期
		Valid() {
			let useValidEndDate = this.detail.validEndDate
			let usevalid = moment(new Date()).format('YYYY年MM月DD日')
			let Valid = this.valid
			if (usevalid <= useValidEndDate) {
				Valid = true
			}
			return Valid
		},
		//申请退款
		Refund() {
			let Refund = this.isRefund
			let useValidEndDate = this.detail.validEndDate
			let usevalid = moment(new Date()).format('YYYY年MM月DD日')
			let valid = this.valid
			if (usevalid <= useValidEndDate) {
				valid = true
			}
			if ((this.detail.orderType === 3 || this.detail.orderType === 1) && this.detail.isRefund === 1 && valid === true) {
				Refund = true
			} else if (this.detail.orderType !== 3 && this.detail.orderType !== 1 && this.detail.isRefund === 1) {
				Refund = true
			}
			return Refund
		},
		val() {
			return this.detail.orderCode
		}
	},
	onLoad(event) {
		this.orderCode = event.orderCode
		this.serviceTime = this.$store.state.storeConfig.serverTimeStart + '-' + this.$store.state.storeConfig.serverTimeEnd
		this.queryData()
	},
	methods: {
		//弹出二维码保存的按钮
		saveQrcode() {

			this.show = true

		},
		//保存二维码
		saveCode() {
			this.$refs.qrcode._saveCode()
			this.show = false
		},
		//取消二维码的弹出层
		onCancel() {
			this.show = false
		},
		//门票、美食、特产的总价计算
		totalPrice(t) {
			if ([1, 3, 4].includes(this.orderType)) {
				return (t.storeSettlementTotalPrice / (t.quantity || 1)).toFixed(2)
			} else if (this.orderType === 5) {
				return (t.storeSettlementTotalPrice / (t.quantity || 1)).toFixed(2)
			}
		},
		//路由的跳转
		handleLink(item) {
			//五种品类产品
			let link = {
				'1': `/pages/beauty/detail?id=${item.bodyId}`,
				'2': `/pages/hotel/detail?id=${item.bodyId}`,
				'3': `/pages/cate/goodsDetail?id=${item.productId}`,
				'4': `/pages/specialty/order?id=${item.productId}`,
				'5': `/pages/route/detail?id=${item.productId}`,
			}
			uni.navigateTo({
				url: link[this.orderType]
			})
		},
		//评价
		toComment(isDetail) {
			uni.navigateTo({
				url: `/pages/comment/main?orderCode=${this.orderCode}&orderType=${this.detail.orderType}&isDetail=${isDetail}`
			})
		},
		//客服
		phone() {
			uni.makePhoneCall({
				phoneNumber: this.$store.state.serviceTel
			})
		},
		//获取详情
		queryData(orderCode) {
			this.$ajax({
				method: 'post',
				url: '/weChat/personalCenter/order/queryDetail',
				data: {
					orderCode: this.orderCode || orderCode
				}
			}).then(res => {
				//基本详情
				this.detail = res.data.orderInfoDetailVo
				this.orderType = this.detail.orderType
				//五种品类产品
				let orderList = {
					1: res.data.ticketOrderDetailVoList,
					2: res.data.hotelOrderDetailVoList,
					3: res.data.foodOrderDetailVoList,
					4: res.data.specialtyOrderDetailVoList,
					5: res.data.lineOrderDetailVoList,
				}
				this.list = orderList[this.orderType]
				this.detail.validStartDate = this.list[0] ? moment(this.list[0].useValidStartDate).format('YYYY年MM月DD日') :
					''
				this.detail.validEndDate = this.list[0] ? moment(this.list[0].useValidEndDate).format('YYYY年MM月DD日') : ''
				//线路
				if (this.orderType === 5 && this.list) {
					this.address = this.list[0].provinceCode === '100' ? '全国出发' : this.list[0].provinceName + this.list[0].cityName
					this.useDate = moment(this.list[0].useDate).format('YYYY年MM月DD日')
				}
				//酒店
				if (this.orderType === 2 && this.list) {
					this.checkInTime = moment(this.list[0].checkInTime).format('YYYY年MM月DD日')
					this.checkOutTime = moment(this.list[0].checkOutTime).format('YYYY年MM月DD日')
				}
				this.expressData = res.data.expressInfoVoList
				if (this.detail.discountPrice === null) {
					this.detail.discountPrice = 0
					this.detail.payPrice = res.detail.orderInfoDetailVo.totalPrice
				}
				this.creatTime = res.data.orderInfoDetailVo.orderTime
				for (let attr in this.detail) {
					if (/Time/.test(attr)) {
						this.detail[attr] = this.detail[attr] ? moment(this.detail[attr]).format('YYYY年MM月DD日 HH:mm:ss') : ''
					}
				}
				//订单详情暂存
				uni.setStorageSync('orderDetail', JSON.stringify(this.detail))
				uni.setStorageSync('prodList', JSON.stringify(this.list))
			})
		},
		// 支付超时
		timeout() {
			this.detail.orderStatusName = '订单关闭，超时未付款'
			this.detail.refundStatus = 0
		},
		//申请退款弹框
		applyRefund() {
			let _this = this
			uni.setStorageSync('prodDetail', JSON.stringify(this.detail))
			uni.showModal({
				content: '如有使用优惠券，退款之后优惠券不退还，确认申请退款吗？',
				success(res) {
					if (res.confirm) {
						let _path = `/pages/personalCenter/order/return?orderId=${_this.orderId}`
						uni.navigateTo({
							url: _path
						})
					} else if (res.cancel) {
						uni.setStorageSync('prodDetail', '')
					}
				}
			})
		},
		//取消退款申请弹框
		cancelBack() {
			let _this = this
			uni.showModal({
				content: '确认取消退款申请吗？',
				success(res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/weChat/pay/cancelRefundV2', // 3.0.2
							data: {
								orderCode: _this.orderId
							}
						}).then(res => {
							_this.queryData(_this.orderId)
							uni.showToast({
								icon: 'none',
								title: '取消成功'
							})
							uni.setStorageSync('refresh', true)
						}).catch(err => {
							uni.showToast({
								icon: 'none',
								title: '取消失败'
							})
						})
					}
				}
			})
		},
		//取消订单
		cancelOrder() {
			let _this = this
			uni.showModal({
				content: '确认取消订单吗？',
				success(res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/weChat/pay/cancelOrder',
							data: {
								orderCode: _this.orderId
							}
						}).then(res => {
							_this.queryData(_this.orderId)
							uni.showToast({
								icon: 'none',
								title: '取消成功'
							})
						}).catch(err => {
							uni.showToast({
								icon: 'none',
								title: '取消失败'
							})
						})
					}
				}
			})
		},
		receipt() {
			let _this = this
			uni.showModal({
				title: '提示',
				content: '确认收货吗？',
				success(res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/verification/specialtyorder/confirmOrder',
							data: {
								orderCode: _this.orderId,
								memberId: _this.$store.state.userInfo.id,
								orderId: _this.detail.id,
							}
						}).then(res => {
							_this.queryData(_this.orderId)
						})
					}
				}
			})
		},
		showPayModal() {
			this.getLeftTime()
			if (this.leftTime !== '00:00') {






			} else {
				uni.showToast({
					title: '支付失效!订单关闭，可在我的订单中查看!即将跳转...',
					icon: 'none',
					duration: 2000
				})
				setTimeout(() => {
					uni.navigateTo({
						url: '/pages/personalCenter/order/index'
					})
				}, 2000)
			}
		}
	}
}
